import axios from "../../axios-dashboard";
import * as actionTypes from './actionTypes';

export const tryLoginStart = () => {
    return {
        type: actionTypes.TRY_LOGIN_START
    }
};

export const tryLoginSuccess = (email, redirect, ssoLoginOnly) => {
    return {
        type: actionTypes.TRY_LOGIN_SUCCESS,
        email: email,
        redirect: redirect,
        ssoLoginOnly: ssoLoginOnly,
    }
}

export const tryLoginFail = (error) => {
    return {
        type: actionTypes.TRY_LOGIN_FAIL,
        error: error
    }
}

export const tryLoginWithEmail = (email) => {
    return dispatch => {
        dispatch(tryLoginStart());
        const loginData = {
            email: email,
        };
        const url = "/try-login";
        axios.post(url, loginData)
            .then(response => {
                dispatch(tryLoginSuccess(email, response.data.redirect, response.data.ssoLoginOnly));
            })
            .catch(err => {
                dispatch(tryLoginFail(err.response.data.error));
            })
    }
}